import { getElementDeclarationFromViewBuilder } from "./getElementDeclarationFromViewBuilder.js";
import { getElementDeclarationFromElementBuilder, isElementBuilder, isViewBuilder, } from "./other.js";
/**
 * Extracts the element declaration from a builder.
 */
export async function getElementDeclarationFromBuilder(builder) {
    if (isElementBuilder(builder)) {
        return getElementDeclarationFromElementBuilder(builder);
    }
    if (isViewBuilder(builder)) {
        return getElementDeclarationFromViewBuilder(builder);
    }
    throw new Error("Unknown element kind");
}
